import RouterComp from "./Router";
export default RouterComp;